import React, { ReactElement, ReactNode } from "react";
import enumStrings, { RoutePaths } from "../../../enumStrings";
import { STAFF_SUPPORT_EMAIL } from "../../../utils/userFacingError";
import { useNavigate } from "react-router-dom";
import {
  StatusCard,
  StatusCardButton,
  StatusCardTone,
} from "../../common/StatusCard";
import StandalonePage from "../../common/StandalonePage";

/**
 * "dashboard": inside the dashboard layout, beside the sidebar (approved
 * Style 1, Moeen Oct 27 2026). "standalone": the dashboard could not load,
 * so the same card shows under the logo header.
 */
export type ErrorPagePlacement = "dashboard" | "standalone";

const ErrorBasePage = ({
  eyebrow,
  subtitle,
  description,
  emailSubject,
  icon,
  tone,
  placement = "dashboard",
  isAlert = false,
  wide = false,
}: {
  eyebrow: string;
  subtitle: string;
  description: string;
  emailSubject: string;
  icon: ReactNode;
  tone: StatusCardTone;
  placement?: ErrorPagePlacement;
  isAlert?: boolean;
  wide?: boolean;
}): ReactElement => {
  const navigate = useNavigate();

  const card = (
    <StatusCard
      isAlert={isAlert}
      wide={wide}
      tone={tone}
      icon={icon}
      eyebrow={eyebrow}
      title={subtitle}
      description={description}
      actions={
        <>
          <StatusCardButton onClick={() => navigate(RoutePaths.home)}>
            {enumStrings.pages.common.buttons.homeButtonText}
          </StatusCardButton>
          <StatusCardButton
            variant="outline"
            onClick={() =>
              (window.location.href = `mailto:${STAFF_SUPPORT_EMAIL}?subject=${encodeURIComponent(
                emailSubject
              )}&body=Please%20state%20your%20issue%20below.`)
            }
          >
            {enumStrings.pages.common.buttons.contactSupportButtonText}
          </StatusCardButton>
        </>
      }
    />
  );

  if (placement === "standalone") {
    return <StandalonePage>{card}</StandalonePage>;
  }

  // The layout content area adds top padding (pt-16 on phones for the menu
  // button, pt-4 on desktop). The grey area fills the rest of the screen.
  return (
    <div className="flex min-h-[calc(100dvh-4rem)] w-full items-center justify-center bg-[#F7F7F8] px-4 py-10 text-black md:-mt-4 md:min-h-screen md:px-10">
      {card}
    </div>
  );
};

export default ErrorBasePage;
